import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MasterDetailModule } from '@sdbn/common';
import { RoutingRuleComponent } from './component/routing-rule.component';

import { ApplicationClientCommonModule } from '@sdbn/common';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    RoutingRuleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MasterDetailModule,
    ApplicationClientCommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    DragDropModule,
    MatInputModule,
    MatCheckboxModule
  ]
})
export class RoutingRuleModule { }

